import type { PmSchedule, PmScheduleBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<PmSchedule, PmScheduleBase>({
  tableName: "pm_schedules",
  viewName: "pm_schedules_enriched",
  searchColumns: ["name"],
  computedColumns: ["assetName", "locationName", "checklistTemplateName"],
});

export class PmScheduleService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
